import { put, retry, all } from 'redux-saga/effects';
import { authClient } from '../api/Client';
import { reject, resolve } from '../api';
import * as types from '../constants';
import { NOTIFICATION } from '../constants';
import {
  errorNotification,
  showNotification,
  successNotification,
  simpleErrorNotification,
} from '../../shared-components/Notifications';
import { saveAs } from 'file-saver';

export function* fileDownload({ fileUUID, file_type }) {
  // console.log('fileType', file_type);
  const fileTypeMapping = {
    csv: 'csv',
    json: 'json',
    stix: 'stix.json',
  };

  try {
    const res = yield retry(4, 500, authClient?.Download?.fileDownload, {
      fileUUID,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      const response = res?.data();

      yield put({
        type: resolve(types?.FILE_DOWNLOAD),
        //payload: res?.data(),
      });
      // showNotification(
      //   successNotification({
      //     statusCode: 200,
      //     message: 'Your password was successfully updated!',
      //   }),
      // );
      const fileBlob = new Blob([response], {
        type: 'text/csv',
      });

      const fileName = `${fileUUID}.${
        fileTypeMapping[file_type.toLowerCase()]
      }`;

      saveAs(fileBlob, fileName);
    } else {
      yield all([
        put({
          type: reject(types?.FILE_DOWNLOAD),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'File download was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   const response = res?.data();
  //   yield put({
  //     type: resolve(types?.FILE_DOWNLOAD),
  //     //payload: res?.data(),
  //   });

  //   const fileBlob = new Blob([response], {
  //     type: 'text/csv',
  //   });

  //   const fileName = `${fileUUID}.${fileTypeMapping[file_type.toLowerCase()]}`;

  //   saveAs(fileBlob, fileName);
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.FILE_DOWNLOAD),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.FILE_DOWNLOAD)),
  //     }),
  //   ]);
  // }
}

export function* fileContentCopy({ fileUUID }) {
  try {
    const res = yield retry(4, 500, authClient?.Download?.fileContentCopy, {
      fileUUID,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.FILE_CONTENT_COPY),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 100,
          message: 'Copied to clipboard!',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.FILE_CONTENT_COPY),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Copy was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.FILE_CONTENT_COPY),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 100,
  //       message: 'Copied to clipboard!',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.FILE_CONTENT_COPY),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.FILE_CONTENT_COPY,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.FILE_CONTENT_COPY),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadResultFile({ fileUUID }) {
  try {
    const res = yield retry(4, 500, authClient?.Download?.loadResultFile, {
      fileUUID,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.LOAD_RESULT_FILE),
        payload: res?.data(),
      });
      // showNotification(
      //   successNotification({
      //     statusCode: 200,
      //     message: 'Copied to clipboard!',
      //   }),
      // );
    } else {
      yield all([
        put({
          type: reject(types?.LOAD_RESULT_FILE),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Load was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.LOAD_RESULT_FILE),
  //     payload: res?.data(),
  //   });
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.LOAD_RESULT_FILE),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.LOAD_RESULT_FILE)),
  //     }),
  //   ]);
  // }
}
